import {
  CTA,
  DesignTokenSizeEnum,
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { ReactNode } from 'react';
import { useTribalContext } from '@/context/tribal';
import Box from '../../Box/Box';
import { StyledFooterModelLinks } from '../Footer.styles';
import PillModal from '../../PillModal/PillModal';
import { StyledConfiguratorCTA } from './FooterModel.styles';

interface FooterModelProps {
  title?: ReactNode;
  description?: ReactNode;
  code: ReactNode;
  single?: boolean;
  isStock?: boolean;
  onClick: () => void;
}

const FooterModels = ({
  title,
  description,
  code,
  single,
  onClick,
  isStock,
  ...restProps
}: FooterModelProps) => {
  const { contentManager } = useTribalContext();

  return (
    <div {...restProps}>
      {title && (
        <Box display="flex" gap={DesignTokenSizeEnum.static200}>
          <Text tag={TextTag.h4} appearance={TokenTextAppearance.copy200} bold>
            {title}
          </Text>
        </Box>
      )}
      {description && (
        <Box mb={DesignTokenSizeEnum.static150}>{description}</Box>
      )}
      <StyledFooterModelLinks single={single}>
        <Box display="flex" alignItems="center">
          {isStock ? (
            !single && (
              <PillModal
                modalProps={{
                  description: contentManager.get('stock-badge-info'),
                }}
              >
                {contentManager.get('stock-badge-label')}
              </PillModal>
            )
          ) : (
            <Text appearance={TokenTextAppearance.copy100} bold>
              {code}
            </Text>
          )}
        </Box>
        <StyledConfiguratorCTA>
          <CTA tag="button" emphasis="secondary" onClick={onClick}>
            {contentManager.get('ctas-goto-configurator')}
          </CTA>
        </StyledConfiguratorCTA>
      </StyledFooterModelLinks>
    </div>
  );
};

export default FooterModels;
